import { useQuery } from '@tanstack/react-query';

import { updateHistory } from '../../../../../api';

export const useRecalculation = () => useQuery({ queryKey: ['updateHistory'], queryFn: updateHistory, enabled: false });
